import axios from 'axios'

var callback

var http = axios.create({
  baseURL: process.env.API_BASE_URL + '/tryout-service',
  headers: { 'Content-Type': 'application/json' },
})

var httpupload = axios.create({
  baseURL: process.env.API_BASE_URL + '/tryout-service',
  headers: {'Content-Type': 'multipart/form-data'},
})

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
      {
        'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
        }
      }).then(function (response) {
        localStorage.setItem('refresh_token', JSON.stringify({
          value: response.data.refresh_token,
          expire: null
        }))

        localStorage.setItem('token', JSON.stringify({
          value: response.data.token,
          expire: null
        }))

        return Promise.resolve(response)
      }).then(function (response) {
        var failedRequest = error.config
        failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
        axios.request(failedRequest).then(function (retryResponse) {
          resolve(retryResponse)
        })
      })
  })

  return refreshAndRetry
})

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}

function getTryoutById(id, callback) {
  var config = getConfig()
  http.get('/tryout/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListTryout(pagination, search, callback) {
  var config = getConfig()
  var url = '/tryouts?'

  if (pagination && pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination && pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination && pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListPublishedTryout(pagination, search,callback) {
  var config = getConfig()
  var url = '/tryouts?status=PUBLISHED&create_group=true'

  if (pagination && pagination.perPage !== undefined && pagination.perPage !== null) url += '&per_page=' + pagination.perPage
  if (pagination && pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination && pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  // http.get('/tryouts?state=PUBLISHED', config).then(function (response) {
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function saveTryout(tryout, callback) {
  var config = getConfig()
  http.post('/tryout', tryout, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function updateTryout(tryout, callback) {
  var config = getConfig()
  http.put('/tryout/' + tryout.id, tryout, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function saveSubtest(subtest, callback) {
  var config = getConfig()
  http.post('/subtest', subtest, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function updateSubtest(subtest, callback) {
  var config = getConfig()
  http.put('/subtest/' + subtest.id, subtest, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function reviewTryout(id, callback) {
  var config = getConfig()
  http.put('/tryout/' + id + '/review', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function publishTryout(id, callback) {
  var config = getConfig()
  http.put('/tryout/' + id + '/publish', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function draftTryout(id, callback) {
  var config = getConfig()
  http.put('/tryout/' + id + '/draft', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

/**
* Tryout Group Related Endpoint
*/

function getListOfTryoutGroups(pagination, search, params, callback) {
  var config = getConfig()
  var url = '/tryout_groups?'

  if (pagination && pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination && pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination && pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.by) url += '&search=' + search.query + '&search_by=' + search.by
  if (params) config.params = params

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function createTryoutGroup(data, callback) {
  var config = getConfig()
  http.post('/tryout_group', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getTryoutGroup(id, callback) {
  var config = getConfig()
  http.get('/tryout_group/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function editTryoutGroup(id, data, callback) {
  var config = getConfig()
  http.put('/tryout_group/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function deleteTryoutGroup(id, callback) {
  var config = getConfig()
  http.delete('/tryout_group/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function publishTryoutGroup(id, callback) {
  var config = getConfig()
  http.put('/tryout_group/' + id + '/publish', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function unPublishTryoutGroup(id, callback) {
  var config = getConfig()
  http.put('/tryout_group/' + id + '/draft', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function listTryoutSource(callback){
  var config = getConfig()
  http.get('/tryout_sources', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function addTryoutIntoGroup(tryoutId, groupId, callback) {
  var config = getConfig()
  http.put('tryout/' + tryoutId + '/group/' + groupId, {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function removeTryoutFromGroup(tryoutId, groupId, callback) {
  var config = getConfig()
  http.delete('/tryout/' + tryoutId + '/group/' + groupId, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListOfTryoutSeries(callback) {
  var config = getConfig()
  http.get('/series', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function createTryoutSeries(data, callback) {
  var config = getConfig()
  http.post('/series', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getTryoutSeries(id, callback) {
  var config = getConfig()
  http.get('/series/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function attachGroupIntoSeries(groupId, seriesId, callback) {
  var config = getConfig()
  var url = '/tryout_group/' + groupId + '/series/' + seriesId
  http.put(url, {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function dettachGroupFromSeries(groupId, seriesId, callback) {
  var config = getConfig()
  var url = '/tryout_group/' + groupId + '/series/' + seriesId
  http.delete(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function resetStateTryout(body, callback) {
  var config = getConfig()
  http.post('/membership/reset', body, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function resetStateTryoutv2(membershipid, callback) {
  var config = getConfig()
  http.post('/membership/'+ membershipid + '/reset', null, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function gradingStateTryout (body, callback) {
  var config = getConfig()
  http.post('/membership/grading', body, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function deleteTryoutSerial(id, callback) {
  var config = getConfig()
  http.delete('/series/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function generateTryout(id, callback)
{
  var config = getConfig()
  http.put('/tryout/'+ id +'/regenerate', {}, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function exportTryout(data, callback) {
  const ht = axios.create({
    baseURL: process.env.API_BASE_URL + '/tryout-service',
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(localStorage.getItem('token')).value,
      'Accept': 'application/octet-stream'
    }})
  ht.post('/tryouts/export', data,
  { responseType: 'blob' })
  .then(res => {
    let blob = new Blob([res.data], { type: res.headers['content-type'] });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'tryout_export_'+ new Date().getTime()+'.json'
    link.click()
  }).catch(err => {
    console.log(err)
  })
}

function importTryout(dataBody, callback)
{
  var config = getConfig()

  httpupload.post('/tryouts/import', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function gradingUtbkScore(id, callback)
{
  var config = getConfig()
  var url = '/administration/' + id + '/grading_utbk'
  http.post(url, {}, config)
    .then(function(response) {
      callback({
        success: true,
        data: {}
      })
    }).catch(function(error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getTop10UtbkRank(id, callback)
{
  var config = getConfig()
  var url = '/administration/' + id + '/top10_utbk'
  http.get(url, config)
    .then(function(response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function(error) {
      callback({
        success: false,
        message: error.message
      })
    })
}



export default
  {
    getTryoutById,
    getListTryout,
    getListPublishedTryout,
    saveTryout,
    updateTryout,
    reviewTryout,
    publishTryout,
    draftTryout,
    saveSubtest,
    updateSubtest,
    getListOfTryoutGroups,
    createTryoutGroup,
    getTryoutGroup,
    editTryoutGroup,
    deleteTryoutGroup,
    publishTryoutGroup,
    unPublishTryoutGroup,
    addTryoutIntoGroup,
    removeTryoutFromGroup,
    getListOfTryoutSeries,
    createTryoutSeries,
    getTryoutSeries,
    attachGroupIntoSeries,
    dettachGroupFromSeries,
    resetStateTryout,
    resetStateTryoutv2,
    deleteTryoutSerial,
    gradingStateTryout,
    exportTryout,
    importTryout,
    generateTryout,
    gradingUtbkScore,
    getTop10UtbkRank,
    listTryoutSource
  }



// WEBPACK FOOTER //
// ./src/services/tryout.js